export default __webpack_public_path__ + "static/media/desktop_hero_03.d838f006.jpg";